import React, {useState} from "react";

import {
  Button,
  Column,
  Columns,
  Control,
  Field,
  Icon,
  Input,
  Modal,
  Section,
  Table,
  Title,
} from "@allxsmith/bestax-bulma";

import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh} from "../../state/selectors";
import {ToastContainer, toast} from "react-toastify";
import {getQueryString} from "../../utils";
import AddPartModal from "./AddPartModal";
import PartRow from "./PartRow";
import PartSearchModal from "../Job/PartSearchModal";


export default function CreateWorkModal({open, setOpen, endpoint, historicWork}) {
  // const prefilledWork = {
  //   description: historicWork.description,
  //   supplier: historicWork.supplier,
  //   labour_labour_cost: historicWork.labour_labour_cost,
  //   labour_hours: historicWork.labour_labour_cost,
  //
  // } : {vehicle_type: vehicleTypes[0]}

  const dispatch = useDispatch();
  let dataFresh = useSelector(getDataFresh);
  let [work, setWork] = useState( {});
  const [, setTypeahead] = useState();
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [partModalOpen, setPartModalOpen] = useState(false);
  const [partLookupSearchModal, setPartLookupSearchModal] = useState(
        {
            modalOpen:false,
            currentSearch: "",
            searchText: "",
            partIndex: 0,
            workIndex: 0
        });

  const onClickAction = () => {
    if (checkAllFieldsFilled()) {
      save();
      setWork({})
      setOpen(false);
    } else {
      toast.error("Please fill in all fields", {position: "top-right"});
    }
  };

  const handleSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=SP&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  }

  const handleWorkSupplierSelect = supplier => {
    let newWork = {...work}
    newWork.supplier = supplier[0];
    setWork(newWork);
  };

  const handleChange = (e, index) => {
    let newWork = {...work};
    newWork[e.target.name] = e.target.value;
    setWork(newWork);
  };

  const checkAllFieldsFilled = () => {
    if (
      false
    ) {
      return false;
    }
    return true;
  };

  const save = () => {
    const url = endpoint + "worklookup";
    const queryString = getQueryString({
      description: work.description,
      labour_cost: work.labour_cost,
      labour_hours: work.labour_hours,
    });
    return axios.get(`${endpoint}worklookup${queryString}`).then((response) => {
      if(response.data.results.length === 0) {
        const conf = {
          method: "post",
          data: work,
          url
        };
        //
        return axios(conf).then(() => {
          dispatch(createSetDataFreshAction(dataFresh + 1));
          setOpen(false);
        });
      } else {
        toast.warning("This work already exists!", {position: "top-right"});
      }
    });
  };



  const selectPart = (part, partIndex, workIndex) => {
    let currentParts = []
    if(work.part_work_lookup){
      currentParts = work.part_work_lookup;
    }
    console.log(currentParts);
    console.log(part);
    currentParts.push(part);
    work.part_work_lookup = currentParts;
    setPartLookupSearchModal({modalOpen: false});
  };


  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  // TODO(bestax-migrate): bestax Icon renders from a `name` prop, not children; convert this icon markup by hand
  // TODO(bestax-migrate): `align` — inside a Control use its hasIconsLeft/iconLeft (or right) props instead
  return (
    <Modal
      closeOnBlur
      active={open}
      onClick={e => {e.stopPropagation()}}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Modal.Content className="wider-modal">
        <Section style={{backgroundColor: "white"}}>
          <Title className="is-centered">Create New Work Lookup</Title>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label">Description</label>
                <Control>
                  <Input
                    type="text"
                    name="description"
                    onChange={handleChange}
                    value={work.description || ""}
                    required
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Supplier</label>
                <Control>
                  <AsyncTypeahead
                    useCache={false}
                    id="typeahead"
                    labelKey="display_name"
                    minLength={2}
                    name={"supplier"}
                    onSearch={handleSearch}
                    onChange={handleWorkSupplierSelect}
                    placeholder={"Search Supplier"}
                    options={searchData}
                    ref={typeahead => setTypeahead(typeahead)}
                    className="typeahead"
                    isLoading={isLoading}
                    selected={work.supplier && work.supplier.id ? [work.supplier] : []}
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Control>
                <Button
                  onClick={() => setPartModalOpen(true)}
                  color={"success"}
                >
                  Add Part +
                </Button>
              </Control>
            </Column>
            <Column>
              <Control>
                <Button
                  onClick={() => (
                      setPartLookupSearchModal({
                          modalOpen: true,
                          currentSearch: "",
                          searchText: "",
                          partIndex: 0,
                          workIndex: 0
                      })
                  )}
                  color={"success"}
                >
                  Search Part
                </Button>
              </Control>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label">Labour Hours</label>
                <Control>
                  <Input
                    type="text"
                    name="labour_hours"
                    onChange={handleChange}
                    value={work.labour_hours || ""}
                    required
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Labour Cost</label>
                <Control className="has-icons-left">
                  <Input
                    type="text"
                    name="labour_cost"
                    onChange={handleChange}
                    value={work.labour_cost || ""}
                    required
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Customer Labour Charge</label>
                <Control className="has-icons-left">
                  <Input
                    type="text"
                    name="customer_labour_cost"
                    onChange={handleChange}
                    value={work.customer_labour_cost || ""}
                    required
                  />
                </Control>
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Button
                color="info"
                onClick={() => {
                  setWork({});
                  setOpen(false);
                }}
                isFullWidth
              >
                Cancel
              </Button>
            </Column>
            <Column>
              <Button color="danger" onClick={onClickAction} isFullWidth>
                Save Work Lookup
              </Button>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Table
              isFullwidth
            >
              <tr className={"table-header-bold"}>
                <th>Part Name</th>
                <th>Part Number</th>
                <th>Supplier</th>
                <th>Cost</th>
                <th></th>
              </tr>
              <tbody>
              {work.part_work_lookup &&
               work.part_work_lookup.map((part, index) => (
                 <PartRow
                  workLookup={work}
                  endpoint={endpoint}
                  dataFresh={dataFresh}
                  index={index}
                 />
               ))
              }
              </tbody>
            </Table>
          </Columns>
          <AddPartModal
            open={partModalOpen}
            setOpen={setPartModalOpen}
            workLookup={work}
            setWorkLookup={setWork}
          />
          <PartSearchModal
            {...partLookupSearchModal}
            setModalState={setPartLookupSearchModal}
            selectPart={selectPart}
          />
        </Section>
      </Modal.Content>
    </Modal>
  );
}
